"use strict";

var _toConsumableArray = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wearable = void 0;

var validation_1 = require("../../../validation");

var wearable_category_1 = require("../../../dapps/wearable-category");

var representation_1 = require("./representation");

var base_item_1 = require("../base-item");

var standard_props_1 = require("../standard-props");

var third_party_props_1 = require("../third-party-props");
/** @alpha */


var Wearable;

(function (Wearable) {
  Wearable.schema = {
    type: 'object',
    properties: Object.assign(Object.assign(Object.assign(Object.assign({}, base_item_1.baseItemProperties), standard_props_1.standardProperties), third_party_props_1.thirdPartyProps), {
      data: {
        type: 'object',
        properties: {
          replaces: {
            type: 'array',
            items: wearable_category_1.WearableCategory.schema
          },
          hides: {
            type: 'array',
            items: wearable_category_1.WearableCategory.schema
          },
          tags: {
            type: 'array',
            items: {
              type: 'string',
              minLength: 1
            }
          },
          representations: {
            type: 'array',
            items: representation_1.WearableRepresentation.schema,
            minItems: 1
          },
          category: wearable_category_1.WearableCategory.schema
        },
        required: ['replaces', 'hides', 'tags', 'representations', 'category']
      }
    }),
    additionalProperties: true,
    required: [],
    oneOf: [{
      required: ['id', 'i18n'],
      prohibited: ['merkleProof', 'content', 'collectionAddress', 'rarity'],
      _isBaseAvatar: true
    }, {
      required: [].concat(_toConsumableArray(base_item_1.requiredBaseItemProps), ['data', 'collectionAddress', 'rarity']),
      prohibited: ['merkleProof', 'content']
    }, {
      required: [].concat(_toConsumableArray(base_item_1.requiredBaseItemProps), ['data', 'merkleProof',
      /* MerkleProof emote required Keys (might be redundant) */
      'content']),
      prohibited: ['collectionAddress', 'rarity'],
      _isThirdParty: true
    }],
    errorMessage: {
      oneOf: 'either standard XOR thirdparty properties conditions must be met'
    }
  };
  var _isThirdPartyKeywordDef = {
    keyword: '_isThirdParty',
    validate: function validate(schema, data) {
      return !schema || (0, third_party_props_1.isThirdParty)(data);
    },
    errors: false
  };
  var _isBaseAvatarKeywordDef = {
    keyword: '_isBaseAvatar',
    validate: function validate(schema, data) {
      return !schema || (0, base_item_1.isBaseAvatar)(data);
    },
    errors: false
  };
  /**
   * Validates that the wearable metadata complies with the standard or third party wearable, and doesn't have repeated locales.
   * Some fields are defined as optional but those are validated to be present as standard XOR third party:
   *  Standard Wearables should contain:
   *    - collectionAddress
   *    - rarity
   *  Third Party Wearables should contain:
   *    - merkleProof
   *    - content
   */

  Wearable.validate = (0, validation_1.generateLazyValidator)(Wearable.schema, [_isThirdPartyKeywordDef, _isBaseAvatarKeywordDef]);
})(Wearable = exports.Wearable || (exports.Wearable = {}));